import React from 'react';

import AdminDictionaryList, { Pair } from '@dashboard/components/AdminDictionaryList';
import Link from '@dashboard/components/mui-atoms/Link';
import { usePlatformQuery } from '@dashboard/generated/wp/administrator';

import { DateFormatter } from '@waypoint/react/formatters';

type Props = {
  platformId: string;
};
export default function PlatformProperties({ platformId }: Props) {
  const { data } = usePlatformQuery({ variables: { id: platformId } });
  return (
    <AdminDictionaryList>
      <Pair label="ID" value={<Link href={`/o/${platformId}`}>{platformId}</Link>} />
      <Pair label="Created At" value={<DateFormatter template="full" value={data?.Platform.createdAt} />} />
      <Pair
        label="Stripe customer id"
        value={
          <Link href={`https://dashboard.stripe.com/customers/${data?.Platform.stripeCustomerId}`} target="_blank">
            {data?.Platform.stripeCustomerId}
          </Link>
        }
      />
      <Pair label="Billing email address" value={data?.Platform.billingEmailAddress} />
      <Pair label="Waypoint tier" value={data?.Platform.activeWaypointTier} />
      <Pair label="Email sending status" value={data?.Platform.sendingStatus} />
      <Pair label="Email sending strategy" value={data?.Platform.waypointSendingStrategy} />
      <Pair label="Raw template preview" value={data?.Platform.featureRawTemplatePreviewEnabled} />
      <Pair label="Legacy template (Outlook)" value={data?.Platform.featureLegacyTemplatesEnabled} />
      <Pair label="Stripe subscription status" value={data?.Platform.stripeSubscriptionStatus} />
    </AdminDictionaryList>
  );
}
